import React from 'react';
import { Typography } from '@mui/material';

interface Props {
  text: string;
  subLabel?: string;
  required?: boolean;
}
export default function Label({ text, subLabel, required }: Props) {
  return (
    <Typography className='text-text-1 text-sm' fontFamily="CircularStd">
      {text}
      {subLabel && <span className="text-muted"> ({subLabel})</span>}
      {required && <span className="ml-2 text-text-2">*</span>}
    </Typography>
  );
}
